module.exports = __webpack_public_path__ + "6d885daff7fd4cf91a7708c96e0ef470.pdf";